export default "__VITE_ASSET__9a4ec70a__"